'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var moment = _interopDefault(require('moment'));

var FORMAT = 'MMM D [at] h:mm a';
var DayAndTime = function (props) {
    var dateTime = props.dateTime, locale = props.locale, incomingFormat = props.incomingFormat;
    if (!dateTime) {
        return null;
    }
    moment.locale(locale || 'en');
    var displayedTime = moment(dateTime, incomingFormat).format(FORMAT);
    return React__default.createElement("span", { "data-testid": 'day-and-time' }, displayedTime);
};

module.exports = DayAndTime;
